import { ListboxSection } from '../listbox/listbox-section.component.js';

/**
 * @subcomponent Menu
 */ const MenuSection = ListboxSection;

export { MenuSection };
